// extracted by mini-css-extract-plugin
module.exports = {"supportive-messages-block":"SupportiveMessagesBlock_supportive-messages-block__app8M"};